import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import { DateTime} from 'luxon';
import '../../css/List.css';
import TextField from '@mui/material/TextField';
import SortComponent from '../CommonComponents/SortComponent';
import { Link } from 'react-router-dom';

function RefferalList(props) {
   const [value,setValue]=useState(null);
    return (
    <div className='mt-3 customer-list-table'>
        
     <Table striped bordered hover responsive>
         <thead>
            <tr className='tablehead'>
                <th>SNo</th>
                <th><SortComponent sort={props.sort} sortby={"referral_code_id"} />Referral Code Id </th>
                <th><SortComponent sort={props.sort} sortby={"customer_id"} />Customer Id </th>
                <th>Customer Name </th>
                <th>Mobile </th>
                <th>Customer Type </th>
                <th>Dairy Name </th>
                <th>Referrer Name </th>
                <th>Referrer Customer Id </th>
                <th>Referrer Telephone </th>
                <th>Referrer Referral Code </th>
                 <th>Created At </th>
            </tr>
            <tr className='text-center'>
                <th> </th>
                <th><input onChange={e=>props.searchParam(e.target.value,"referral_code_id")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"customer_id")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"customer_name")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"telephone")}/></th>
              <th> 
                    <select className="form-select text-center" aria-label="Default select example" style={{width: "170px"}} onChange={e=>props.searchParam(e.target.value,"customer_group_id")}>
                            <option  value="">All</option>
                            <option value="1">Kisan</option>
                            <option value="2">Dairy Owner</option>
                        </select>
                </th>
                <th><input onChange={e=>props.searchParam(e.target.value,"dairy_name")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"referrer_name")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"referrer_customer_id")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"referrer_telephone")}/></th>
                <th><input onChange={e=>props.searchParam(e.target.value,"referrer_referral_code")}/></th>
                <th><TextField type="date" className='text-center' onChange={e=>props.searchParam(e.target.value,"created_at")}/></th>
            </tr>
         </thead>
          <tbody>
            { 
                props.data.map((list,count) =>{
                    return( 
                    <tr className='text-center' key={list.id}>
                    <td>{++count}</td>
                    <td>{list.referral_code_id}</td>
                    <td>{list.customer_id}</td>
                    <td>{(list.customer?.firstname||list.customer?.lastname)? list.customer.firstname+" "+list.customer.lastname:"---"}</td>
                    <td>{(list.customer?.telephone)? list.customer.telephone:"---"}</td>
                    <td>{(list.customer?.customer_group_id != null && list.customer.customer_group_id == 1) ? "Kisan" : "Dairy Owner"}</td>
                    <td>
                        {list.customer?.dairies?.map((dairy) => (
                            <div key={dairy.id}>{dairy.id}-{dairy.name}</div>
                        ))}
                    </td>
                    <td>{(list.customer_referral?.customer?.firstname||list.customer_referral?.customer?.lastname)? list.customer_referral.customer.firstname+" "+list.customer_referral.customer.lastname:"---"}</td>
                    <td>{(list.customer_referral?.customer?.customer_id)? list.customer_referral.customer?.customer_id:"---"}</td>
                    <td>{(list.customer_referral?.customer?.telephone)? list.customer_referral.customer.telephone:"---"}</td>
                    <td>{(list.customer_referral?.code)? list.customer_referral.code:"---"}</td>
                    <td>{list.created_at ? DateTime.fromISO(list.created_at).toFormat("dd-LLL-yyyy"):"---"}</td>
                    </tr>
                    )})
            }
        </tbody>
        </Table>
   
    
  </div>
  )
}

export default RefferalList